import graphqlClient from "@/GQLClient";
import type { MealDishFragment } from "@/graphql";
import {
  DeleteMealDishDocument,
  GetMealDishesDocument,
  SaveMealDishDocument,
  type MealDishInput,
} from "@/graphql/generated-types";
import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";

const getAll = async (): Promise<MealDishFragment[]> => {
  const response = await graphqlClient.query({
    query: GetMealDishesDocument,
    variables: {},
  });

  if (response.data.institutions?.getMyInstitution.mealDishes) {
    return response.data.institutions?.getMyInstitution.mealDishes.edges
      .map((edge) => edge.node)
      .filter((node) => node.__typename === "MealDish") as MealDishFragment[];
  }

  throw new SentryGraphQLError();
};

const save = async (dish: MealDishInput) => {
  const response = await graphqlClient.mutate({
    mutation: SaveMealDishDocument,
    variables: {
      dish,
    },
  });

  if (response.data?.meal?.saveDish.success) {
    return response.data.meal.saveDish;
  }

  throw new SentryGraphQLError();
};

const deleteItem = async (id: string) => {
  const response = await graphqlClient.mutate({
    mutation: DeleteMealDishDocument,
    variables: {
      id,
    },
  });

  if (response.data?.meal?.deleteDish.success) {
    return response.data.meal.deleteDish;
  }

  throw new SentryGraphQLError();
};

export default {
  getAll,
  save,
  deleteItem,
};
